<template>
  <el-dialog
    top="5vh"
    width="1200px"
    class="page-dialog center-dialog"
    :visible="visible"
    title="代理模式设置"
    @close="$emit('update:visible', false)"
    @closed="handleClosed"
  >
    <div style="height: 70vh; overflow-y: auto; overflow-x: hidden">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="返佣模式" prop="back_model_type">
          <el-radio-group v-model="form.back_model_type">
            <el-radio
              v-for="item in modeOptions"
              :key="item.value"
              :label="item.value"
              :value="item.value"
              :disabled="item.disabled"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <div
          style="
            margin: -22px 0 22px 140px;
            width: 400px;
            background-color: #f4f4f5;
            color: #909399;
            padding: 10px;
            border-radius: 5px;
          "
        >
          <ul style="list-style: none; padding: 0; margin: 0">
            <li>全民代理返佣以用户<span style="font-weight: bold">有效投注</span>计算。</li>
            <li>直接下级贡献佣金：返佣比例为2%，有效投注为{{ amountUnit }}100，则贡献{{ amountUnit }}2</li>
            <li>二级代理贡献佣金：返佣比例为1%，有效投注为{{ amountUnit }}100，则贡献{{ amountUnit }}1</li>
          </ul>
        </div>
        <el-form-item label="代理计算层级" prop="level_count">
          <el-select v-model="form.level_count" placeholder="请选择">
            <el-option
              v-for="item in levelCountOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="rate-item">
          <el-form-item label="直属代理佣金比例" prop="share_one_rate">
            <el-input-number
              v-model="form.share_one_rate"
              :controls="false"
              :step="0.01"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <div class="suffix">%</div>
        </div>
        <div class="rate-item">
          <el-form-item label="二级代理佣金比例" prop="share_two_rate">
            <el-input-number
              v-model="form.share_two_rate"
              :controls="false"
              :step="0.01"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <div class="suffix">%</div>
        </div>
        <el-divider></el-divider>

        <div class="time-range-item">
          <div class="time-range-item-radio">
            <el-radio v-model="radio" label="1">每天</el-radio>
          </div>
          <el-form-item label="佣金领取时间" prop="reward_time_range">
            <el-time-picker
              v-model="form.reward_time_range"
              is-range
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="请选择时间范围"
            ></el-time-picker>
          </el-form-item>
        </div>
        <div class="rate-item">
          <el-form-item label="佣金打码倍数" prop="reward_lock_multiple">
            <el-input-number
              v-model="form.reward_lock_multiple"
              :controls="false"
              :step="0.01"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <div class="suffix">倍</div>
        </div>
        <el-form-item label="推广描述" prop="share_desc">
          <Tinymce :key="tinymceKey" v-model="form.share_desc" :height="260" language="zh" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer"></div>
    </div>
    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确认</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { AgentApi } from '@/api/agent'
import Tinymce from '@/components/Tinymce'
import config from '@/config'

const amountUnit = config.amountUnit

const BACK_MODEL_TYPE_OPTIONS = [
  {
    value: 1,
    label: '全民代理',
  },
  {
    value: 2,
    label: '无限极差',
    disabled: true,
  },
]

const LEVEL_COUNT_OPTIONS = [
  {
    value: 2,
    label: '二级',
  },
  {
    value: 3,
    label: '三级',
  },
]

export default {
  name: 'AgentModeSettingDialog',
  components: {
    Tinymce,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      amountUnit,
      modeOptions: BACK_MODEL_TYPE_OPTIONS,
      levelCountOptions: LEVEL_COUNT_OPTIONS,
      radio: '1',
      tinymceKey: 0,
      form: {
        // 返佣模式
        back_model_type: 1,
        // 代理计算层级
        level_count: 2,
        // 奖励打码倍数
        reward_lock_multiple: undefined,
        // // 直属代理佣金比例
        share_one_rate: undefined,
        // // 二级代理佣金比例
        share_two_rate: undefined,
        // 奖励时间范围
        reward_time_range: [new Date(2000, 1, 1, 8, 0, 0), new Date(2000, 1, 1, 23, 59, 59)],
        // 推广描述
        share_desc: '',
      },
      rules: {
        back_model_type: [{ required: true, message: '请选择返佣模式', trigger: 'change' }],
        level_count: [{ required: true, message: '请选择代理计算层级', trigger: 'change' }],
        reward_lock_multiple: [{ required: true, message: '请输入佣金打码倍数', trigger: 'blur' }],
        share_one_rate: [{ required: true, message: '请输入直属代理佣金比例', trigger: 'blur' }],
        share_two_rate: [{ required: true, message: '请输入二级代理佣金比例', trigger: 'blur' }],
        reward_time_range: [{ required: true, message: '请选择佣金领取时间', trigger: 'change' }],
      },
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.getAgentModeSetting()
      }
    },
  },
  methods: {
    toTimeRange(start, end) {
      return [new Date(start), new Date(end)]
    },
    async getAgentModeSetting() {
      const res = await AgentApi.getAgentModeSetting()
      console.log(res)
      if (res.code === 0) {
        const isUnset = res.data.back_model_type !== 1 && res.data.back_model_type !== 2

        if (isUnset) {
          return
        }

        this.form = {
          back_model_type: res.data.back_model_type,
          level_count: res.data.level_count,
          reward_lock_multiple: res.data.reward_lock_multiple,
          share_one_rate: res.data.share_one_rate,
          share_two_rate: res.data.share_two_rate,
          reward_time_range: this.toTimeRange(res.data.reward_time_start, res.data.reward_time_end),
          share_desc: res.data.share_desc,
        }
        this.tinymceKey++
        console.log(this.form)
      }
    },
    handleSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) {
          return
        }

        const params = {
          back_model_type: this.form.back_model_type,
          level_count: this.form.level_count,
          reward_lock_multiple: this.form.reward_lock_multiple,
          share_one_rate: this.form.share_one_rate,
          share_two_rate: this.form.share_two_rate,
          share_desc: this.form.share_desc,
          reward_time_start: Math.floor(this.form.reward_time_range[0].getTime()),
          reward_time_end: Math.floor(this.form.reward_time_range[1].getTime()),
        }

        console.log(this.form.reward_time_range)

        const res = await AgentApi.saveAgentModeSetting(params)
        if (res.code === 0) {
          this.$message.success('保存成功')
          this.$refs.formRef?.resetFields()
          this.$emit('closed')
        }
      })
    },
    handleClosed() {
      this.$refs.formRef?.resetFields()
      this.$emit('closed')
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: center;
}

.rate-item {
  position: relative;
}

.suffix {
  position: absolute;
  left: 318px;
  top: 50%;
  transform: translateY(-50%);
}

.agent-mode-setting-dialog {
  ::v-deep {
    .el-input-number input {
      text-align: left;
    }
  }
}

.time-range-item {
  position: relative;

  ::v-deep {
    .el-date-editor {
      margin-left: 68px;
    }
  }
}

.time-range-item-radio {
  position: absolute;
  left: 142px;
  top: 50%;
  transform: translateY(-50%);
}
</style>
